/**
 * Retrieves clipboard text from ClipboardEvent.
 */
export function getEventClipboardText(event: ClipboardEvent) {
  if (event.clipboardData) {
    return event.clipboardData.getData("text/plain")
  }
}
